import { ApiClient } from "zoox-infra";
export default class BaseService {
  constructor() {
    this.apiClient = new ApiClient();
  }

  async getWithCache(url, showException = true, showLoading = true) {
    const now = new Date();
    const newVersion = process.env.VUE_APP_UPDATED_VERSION;
    const cached = JSON.parse(localStorage.getItem(url) || "{}");
    if (
      cached.item == null ||
      cached.expiresIn < now.getTime() ||
      newVersion !== cached.version
    ) {
      cached.item = await this.apiClient.get(url, showException, showLoading);
      if (cached.item != null) {
        localStorage.setItem(
          url,
          JSON.stringify({
            item: cached.item,
            expiresIn: now.setHours(now.getHours() + 24),
            version: process.env.VUE_APP_VERSION
          })
        );
      }
    }
    return cached.item;
  }
}
